const GREEN = '#2AB57B';
const BLUE = '#5CC3FF';
const PURPLE = '#492EFD';

const COLORS = {
  GREEN,
  BLUE,
  PURPLE
};

export default COLORS;



// WEBPACK FOOTER //
// ./src/constants/colors.js